import { useElementMetadata } from "@/components/contexts/ElementMetadataContext";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export interface AssetsElement {
  type: "native" | "component" | "storybook-component" | "reactcomponent";

  // For native tags
  nativeTag?: string;

  // For non-native tags
  codebaseId?: string;
  filename?: string;
  componentName?: string;

  // For storybook components only
  importsForStory?: any[];
  storybookSourceStart?: number;
  storybookSourceEnd?: number;
  library?: string;
  isTemplateStory?: boolean;

  // For previews
  fileHash?: string;

  // For reactcomponents
  contents: string;
  image_url: string;
  name: string;
}

export const useImagePreview = (element: AssetsElement) => {
  const { metadata } = useElementMetadata();
  const elementsToFetch = useSelector(
    (state: any) => state.metadata.elementsToFetch
  );
  const isFetching = useSelector((state: any) => state.metadata.isFetching);

  const { imagePath, metadataStatus, error } = useMemo(() => {
    let imagePath = null;
    let error = false;

    const fileHash = element.fileHash;
    const metadataStatus =
      isFetching && elementsToFetch[0] === element.codebaseId
        ? "processing"
        : elementsToFetch.includes(element.codebaseId)
        ? "pending"
        : "done";

    if (fileHash && metadata && metadata[fileHash]) {
      imagePath = metadata[fileHash].error
        ? null
        : metadata[fileHash].previewUrl;
      error = !!metadata[fileHash].error;
    }

    // Add additional logic for specific element types
    if (element?.type === "storybook-component") {
      const storyName = element?.filename
        ? element.filename.split("/").pop()
        : undefined;
      const { componentName, library } = element;
      if (library && storyName && componentName) {
        // @ts-expect-error TS2322
        imagePath = `https://storage.googleapis.com/tempo-image-previews/${library}/${storyName}/${componentName}.png`;
      }
    } else if (element?.type === "reactcomponent") {
      // @ts-expect-error TS2322
      imagePath = element.image_url;
    }

    return { imagePath, metadataStatus, error };
  }, [element, metadata, elementsToFetch, isFetching]);

  return { imagePath, metadataStatus, error };
};
